
/** @format */

import React, { useState, useRef, useEffect } from 'react';
import { PageContainer, FilterPod, TableComponents, SimpleDialog, Icons } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import initFilters from './constants/InitFiltering';
import Services from './services/AssignedSubscriptionsServices';
import { getBusinessCallbackUri } from '../../Financial/services/DetailAccountsServices';
import { columns, generateData } from './components/Columns';
import { DedicatedActivation } from './components/DedicatedActivation';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import {useCurrencyUnit} from 'hooks';

// TODO: Add exporting
// TODO: Detail button is not responsive

// The most completed MaterialTable acroos the project (but with FilterPod component).
const AssignedDelegation = () => {
  // -- STATES --//
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [dedicatedActivation, setDedicatedActivation] = useState(null);
  const [businessCallBackUri, setBusinessCallBackUri] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState(null);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'listSubscriptionsPage',
      'newSubscriptionBtn',
      'exclusiveActiveSubscriptionsBtn',
      'editSubscriptionsBtn',
      'backDefineSubscriptionsBtn'
    ])
  const classes = useStyles();

  const currencyText = useCurrencyUnit(false);
  const [filters, setFilters] = useState(initFilters(currencyText));


  // --HOOKS--//
  const navigate = useNavigate();
  const tableRef = useRef();

  useEffect(() => {
    if (actionsList['listSubscriptionsPage'] || actionsList['backDefineSubscriptionsBtn']) {
      getCallBackUri();

    }
  }, []);

  const getCallBackUri = async () => {
    try {
      const res = await getBusinessCallbackUri({ active: true });
      if (res?.result) {
        for (let item of res?.result) {
          item['label'] = item['url'];
          item['value'] = item['url'];
        }
      }
      setBusinessCallBackUri(res?.result || []);
    } catch (error) {

    }
  };

  const getList = async (query) => {

    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getSubscriptions(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };



  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {

    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const onClickEdit = (id) => {
    navigate(`/subscriptions/assigned/${id}`);
  };

  const hint = 'در این بخش می‌توانید لیست طرح‌های اشتراک ایجاد شده توسط خود را مشاهده کنید.';

  return (
    <PageContainer
      title="طرح‌های تعریف شده"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.SUBSCRIPTIONS_ASSIGNED}
      className={classes.root}
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {(actionsList['listSubscriptionsPage'] || actionsList['backDefineSubscriptionsBtn']) && (
            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          )}
          {actionsList['newSubscriptionBtn'] && (

            <Button
              startIcon={<Icons icon='plusCircle' color="#fff" size="18" />}
              variant="contained"
              color="primary"
              onClick={() => navigate('/subscriptions/create')}
            >
              طرح اشتراک جدید
            </Button>
          )}

        </Box>
        {(actionsList['listSubscriptionsPage'] || actionsList['backDefineSubscriptionsBtn']) && (
          <Box>
            <FilterPod
              filters={filters}
              onChange={onFiltersChange}
              openFilterDialog={openFilterDialog}
              setOpenFilterDialog={setOpenFilterDialog}
              handleCloseFilterDialog={handleCloseFilterDialog}
            />
          </Box>
        )}

      </Grid>
      {((actionsList['listSubscriptionsPage'] || actionsList['backDefineSubscriptionsBtn']) && currencyText) && (
        <TableComponents
          data={getList}
          columns={columns(actionsList, onClickEdit, setDedicatedActivation, setSubscriptionType , currencyText)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber)
            setSize(ps?.pageSize)
            return getList(ps)
          }}
        />

      )}

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={dedicatedActivation !== null}
        title="فعال سازی اختصاصی"
        onClose={() => setDedicatedActivation(null)}
      >
        <DedicatedActivation
          id={dedicatedActivation}
          otherData={businessCallBackUri}
          subscriptionType={subscriptionType}
        />
      </SimpleDialog>
    </PageContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
    '& .MuiTableCell-paddingNone': {
      width: 145,
    },
    // '& .MuiSelect-selectMenu': {
    //   padding: '0 !important'
    // }
  },
  creationBtn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
  },
  chip: {
    margin: 0,
    padding: '3px',
    paddingBottom: 0,
    height: 27,
  },
  chipContainer: {
    '& .MuiSelect-selectMenu': {
      height: 38,
      padding: 4,
      boxSizing: 'border-box',
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
}));

export default AssignedDelegation;

